import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter, Route } from "react-router-dom";
import "../src/index.css";

// plugins styles from node_modules
import "react-perfect-scrollbar/dist/css/styles.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
// plugins styles downloaded
import "assets/vendor/nucleo/css/nucleo.css";
// core styles
import "assets/scss/argon-dashboard-pro-react.scss?v1.2.0";
// import "assets/css/custom.css";

import AdminLayout from "layouts/Admin.js";
import CompanyLayout from "layouts/Company.js";
import Login from "views/pages/Login.js";
import ResetPassword from "views/pages/ResetPassword.js";
import { CookiesProvider } from "react-cookie";

ReactDOM.render(
  <>
    <CookiesProvider>
      <BrowserRouter>
        <Route exact path="/" component={Login} />
        <Route exact path="/reset-password/:token" component={ResetPassword} />
        <Route path="/admin" component={AdminLayout} />
        <Route path="/company" component={CompanyLayout} />
        {/* <Redirect from="*" to="/" /> */}
      </BrowserRouter>
    </CookiesProvider>
  </>,
  document.getElementById("root")
);
